import React from "react";
import { FaArrowTrendUp, FaPeopleArrows, FaSliders } from "react-icons/fa6";
import pumps from "../assets/banner6.jpg";

export default function Pumps() {
  const features = [
    {
      icon: <FaPeopleArrows size={20} className="text-primary" />,
      text: "Transformation programs that align people, process, and technology around stronger execution.",
    },
    {
      icon: <FaSliders size={20} className="text-primary" />,
      text: "Digital change initiatives that simplify workflows and modernize how teams operate.",
    },
    {
      icon: <FaArrowTrendUp size={20} className="text-primary" />,
      text: "Structured improvement efforts focused on efficiency, resilience, and future scalability.",
    },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">Digital Transformation Solutions</h2>
          <p className="section-copy">
            Nova Technologies supports digital transformation with a practical, business-led
            approach that focuses on measurable improvement.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={pumps} alt="Digital Transformation Solutions" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Transformation work is most effective when technology is paired with clarity
            around processes, adoption, and long-term goals. Nova helps organizations move
            forward with digital change that is structured, realistic, and sustainable.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map((item) => (
              <li key={item.text} className="detail-feature-item">
                {item.icon}
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Identify transformation priorities and operating bottlenecks.</li>
            <li>Design a workable path across systems, workflows, and teams.</li>
            <li>Implement improvements in manageable, value-driven phases.</li>
            <li>Support adoption and continuous optimization after rollout.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}
